var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BackendHttpService } from '../../core/backend-http.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
var DashboardService = /** @class */ (function (_super) {
    __extends(DashboardService, _super);
    function DashboardService(router, translate, http) {
        var _this = _super.call(this, router, translate) || this;
        _this.router = router;
        _this.translate = translate;
        _this.http = http;
        return _this;
    }
    DashboardService.prototype.searchDashboardPost = function () {
        // Here we put mock data
        return this.http.get('/assets/mock-data/dashboard-posts.json');
    };
    DashboardService.prototype.fetchRecentMessages = function () {
        // Todo: This is mock data
        return Observable.of([
            { status: 1, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 1, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
            { status: 0, sender: 'Adidas Denmark', message: 'quis nostrud exercitation dolor ullamco labois nisi ut aliquip ex ea commodo' },
        ]);
    };
    return DashboardService;
}(BackendHttpService));
export { DashboardService };



// WEBPACK FOOTER //
// ./src/app/services/dashboard/dashboard.service.ts.pre-build-optimizer.js